import { Wrapper } from '@/components/OpenFeature/Wrapper';
import { FC } from 'react';
import { TemplateInvoiceList } from './template/List';

export const Invoice: FC = () => {
  return (
    <Wrapper isProto={false}>
      <TemplateInvoiceList />
    </Wrapper>
  );
};
